var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 4.99998H9.99984L8.82484 3.82498C8.50817 3.50831 8.08317 3.33331 7.6415 3.33331H3.33317C2.4165 3.33331 1.67484 4.08331 1.67484 4.99998L1.6665 15C1.6665 15.9166 2.4165 16.6666 3.33317 16.6666H16.6665C17.5832 16.6666 18.3332 15.9166 18.3332 15V6.66665C18.3332 5.74998 17.5832 4.99998 16.6665 4.99998ZM12.4998 7.49998C13.4165 7.49998 14.1665 8.24998 14.1665 9.16665C14.1665 10.0833 13.4165 10.8333 12.4998 10.8333C11.5832 10.8333 10.8332 10.0833 10.8332 9.16665C10.8332 8.24998 11.5832 7.49998 12.4998 7.49998ZM15.8332 14.1666H9.1665V13.3333C9.1665 12.225 11.3915 11.6666 12.4998 11.6666C13.6082 11.6666 15.8332 12.225 15.8332 13.3333V14.1666Z",
    fill: "#001B53",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderShare);
export default __webpack_public_path__ + "static/media/folder-share.4cb322363536087ff8badfd1dabd641a.svg";
export { ForwardRef as ReactComponent };